import { useEffect, useRef } from 'react';

let nextOverlayId = 0;

/**
 * Gives an overlay one browser-history entry. Back closes the topmost overlay
 * before navigation can reach the page behind it.
 */
export default function useOverlayHistory({ open, onClose }) {
  const onCloseRef = useRef(onClose);
  const markerRef = useRef(null);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!open || typeof window === 'undefined') return undefined;

    const marker = `suarte-overlay-${++nextOverlayId}`;
    markerRef.current = marker;
    window.history.pushState({ ...(window.history.state || {}), suarteOverlay: marker }, '', window.location.href);

    const handlePopState = (event) => {
      if (event.state?.suarteOverlay !== marker) {
        markerRef.current = null;
        onCloseRef.current?.();
      }
    };
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
      if (markerRef.current === marker && window.history.state?.suarteOverlay === marker) {
        markerRef.current = null;
        window.history.back();
      }
    };
  }, [open]);
}
